require("jquery-validation");
require("jquery-validation/dist/additional-methods");

$(() => {
  let form = $("form").not("[noValid]") || $("form:not(.noValid)");

  $(".iptText").keydown(function(e) {
    let a = e.key;
    if (a.length == 1) return /^[a-zA-Z\s ñáéíóúÑÁÉÍÓÚ]+$/i.test(a);
    return true;
  });

  $(".iptNumber").keydown(function(e) {
    let a = e.key;
    if (a.length == 1) return /[0-9]|\+|-/.test(a);
    return true;
  });

  $.validator.addMethod(
    "emailonly",
    function(value, element) {
      return (
        this.optional(element) ||
        /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/i.test(
          value
        )
      );
    },
    "Ingrese email valido"
  );

  function validForm(formulario) {
    $(formulario).validate({
      errorPlacement: function errorPlacement(error, element) {
        element.before(error);
      },
      rules: {
        email: {
          required: true,
          email: true,
          emailonly: true
        },
        ucr_email: {
          required: true,
          email: true,
          emailonly: true
        },
        ucr_password: {
          required: true
        },
        ucr_password_confirmation: {
          required: true,
          equalTo: "#ucr_password"
        },
        password_actual: {
          required: true
        },
        new_password: {
          required: true
        },
        new_password_confirmation: {
          required: true,
          equalTo: "#new_password"
        },
        password: {
          required: true
        },
        password_confirmation: {
          required: true,
          equalTo: "#password"
        }
      },
      highlight: function(element) {
        let el = $(element);
        el.parent().addClass("error");
      },
      unhighlight: function(element) {
        let el = $(element);
        el.parent().removeClass("error");
      },
      errorPlacement: function(error, element) {}
    });
  }

  for (f of form) {
    validForm(f);
  }
});
